import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-style-seven',
  templateUrl: './pricing-style-seven.component.html',
  styleUrls: ['./pricing-style-seven.component.scss']
})
export class PricingStyleSevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
